export default __webpack_public_path__ + "static/media/provesional_restoration_lower_22_2@2x.8d8ac4f5.png";